import PageSectionContainer from 'components/page/PageSectionContainer';
import GetConfigurationUpdateForm from 'components/service-center/GetConfigurationUpdateForm';

const ConfigurationUpdateSection = () => {
  return (
    <PageSectionContainer className="section__update-checker">
      <GetConfigurationUpdateForm />
    </PageSectionContainer>
  );
};

export default ConfigurationUpdateSection;
